import React, { useState } from "react";
import "./CPassword.css";
import toast from "react-hot-toast";
import { Button, Spinner } from "flowbite-react";
import Backend from "../../../../Backend/Backend";

const Mousetrap = require("mousetrap");

const backend = await new Backend().init();

export default function CPassword() {
  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [cofpassword, setCofPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const Submit = () => {
    if (!oldpassword) {
      toast.error("Old Password Not Found !");
    } else if (!newpassword) {
      toast.error("New newpassword Not Found !");
    } else if (!cofpassword) {
      toast.error("Confirm Password Not Found !");
    } else if (newpassword != cofpassword) {
      toast.error("Passowrd Not Same !");
    } else {
      setLoading(true);

      let data = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        server: localStorage.getItem("server"),
        username: localStorage.getItem("username"),

        oldpassword: oldpassword,
        cpassword: newpassword,
      };

      backend.cpassword(data).then((r) => {
        setLoading(false);
        if (r.error == "False") {
          toast.success(r.message);
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  Mousetrap.bind("enter", function () {
    Submit();
  });

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div class="relative w-full max-w-md max-h-full">
        <div className="loginMain relative bg-white rounded-lg  dark:bg-gray-700">
          <div class="p-4 md:p-5">
            <div class="space-y-4">
              <div>
                <label for="server" class="label">
                  OLD PASSWORD
                </label>
                <input
                  type="text"
                  name="oldpassword"
                  id="oldpassword"
                  autoComplete="new-password"
                  class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  placeholder="Enter Your Old Password"
                  value={oldpassword}
                  onChange={(e) => {
                    setOldPassword(e.target.value);
                  }}
                />
              </div>

              <div>
                <label for="password" class="label">
                  NEW PASSWORD
                </label>
                <input
                  type="text"
                  name="newpassword"
                  id="newpassword"
                  autoComplete="new-password"
                  placeholder="Enter Your Username"
                  class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  value={newpassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                  }}
                />
              </div>

              <div>
                <label for="password" class="label">
                  CONFIRM PASSWORD
                </label>
                <input
                  type="password"
                  name="cofpassword"
                  id="cofpassword"
                  placeholder="••••••••"
                  autoComplete="new-password"
                  class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                  value={cofpassword}
                  onChange={(e) => {
                    setCofPassword(e.target.value);
                  }}
                />
              </div>

              <Button
                onClick={!loading ? Submit : null}
                className="w-full mt-4  max-w text-white font-semibold !bg-[var(--primary)] hover:brightness-90 focus:ring-0 focus:outline-none transition-all rounded-lg flex items-center justify-center text-center"
              >
                <div className="flex items-center justify-center gap-2">
                  {loading && <Spinner size="sm" />}
                  {!loading && "SUBMIT"}
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
